import api from './api';

class PortfolioService {
  // Buscar todos os portfólios
  async getAll(params = {}) {
    try {
      const requestData = {
        page: params.page || 1,
        pageSize: params.pageSize || 1000,
        name: params.name || '',
        projectId: params.projectId || '',
        sorterField: params.sorterField || '',
        sortOrder: params.sortOrder || 'desc'
      };
      
      const response = await api.post('/portfolio/getAll', requestData);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar portfólios:', error);
      throw error;
    }
  }

  // Buscar portfólio por ID
  async getById(id) {
    try {
      const response = await api.get(`/portfolio/getById/${id}`);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar portfólio:', error);
      throw error;
    }
  }

  // Criar ou atualizar portfólio (upsert)
  async upsert(portfolioData) {
    try {
      
      const response = await api.post('/portfolio/upsert', portfolioData);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao salvar portfólio:', error);
      throw error;
    }
  }

  // Deletar portfólio
  async delete(id) {
    try {
      const response = await api.delete(`/portfolio/${id}`);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao deletar portfólio:', error);
      throw error;
    }
  }

  // Mapear dados do backend para frontend
  mapToFrontend(backendData) {
    
    const mappedData = {
      id: backendData.id,
      name: backendData.name,
      description: backendData.description,
      projectId: backendData.projectId,
      reports: backendData.reports || [],
      portfolioReports: backendData.portfolioReports || [],
      createdAt: backendData.createdAt,
      updatedAt: backendData.updatedAt
    };
    
    return mappedData;
  }

  // Mapear dados do frontend para backend
  mapToBackend(frontendData) {
    
    // Converter selectedReports para portfolioReports com posição
    const portfolioReports = frontendData.selectedReports?.map((reportId, index) => ({
      reportId: reportId,
      position: frontendData.reportPositions?.[reportId] || index + 1
    })) || [];
    
    const mappedData = {
      id: frontendData.id,
      name: frontendData.name,
      description: frontendData.description,
      projectId: frontendData.projectId,
      portfolioReports: portfolioReports
    };
    
    return mappedData;
  }

  // Buscar portfólios por projeto
  async getByProject(projectId) {
    try {
      const response = await api.get(`/portfolio/project/${projectId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar portfólios do projeto:', error);
      throw error;
    }
  }

  // Associar relatórios ao portfólio
  async associateReports(portfolioId, reportIds) {
    try {
      const response = await api.post(`/portfolio/${portfolioId}/reports`, {
        reportIds: reportIds
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao associar relatórios:', error);
      throw error;
    }
  }


   async sharePortfolio(portfolioId) {
    try {
      
      const response = await api.post('/portfolio/share', {
        portfolioId: portfolioId
      });
      return response;
    } catch (error) {
      console.error('❌ Erro ao compartilhar relatório:', error);
      throw error;
    }
  }

  // Renovar PIN do portfólio
  async renewPinCode(portfolioId) {
    try {
      const response = await api.post('/reports/renewPinCode', { reportId: portfolioId });
      return response;
    } catch (error) {
      console.error('❌ Erro ao renovar PIN do portfólio:', error);
      throw error;
    }
  }

  // Criar link de compartilhamento específico para portfolio
  async createSharedLink(linkData) {
    try {
      const response = await api.post('/portfolio/share/new', {
        portfolioId: linkData.reportId, // ShareModal usa reportId como prop genérica
        title: linkData.title,
        dimension: linkData.dimension,
        period: linkData.period
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao criar link de compartilhamento de portfólio:', error);
      throw error;
    }
  }

  // Remover associação de relatórios do portfólio
  async removeReports(portfolioId, reportIds) {
    try {
      const response = await api.delete(`/portfolio/${portfolioId}/reports`, {
        data: { reportIds: reportIds }
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao remover relatórios:', error);
      throw error;
    }
  }
}

export default new PortfolioService(); 